// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay--vh7wDCYSi7"};